package app.properties

enum class UserType(val id: Int, val value: String) {
    AMDIN(0,"Ադմին"),
    MANAGER(1, "Մենեջեր")
}

class User(var id: String? = null,
           var login: String,
           var pass: String,
           var email: String,
           var type: Int,
           var newPass: String? = null) {

    fun isUserValid() : Boolean {
        return (login != "" &&
                Credit.emailRegex.containsMatchIn(email) &&
                newPass != "" &&
                newPass != null)
    }
}